var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "guests-and-rooms-input" }, [
    _c("div", { staticClass: "input-line" }, [
      _c("div", { staticClass: "label" }, [
        _c("span", { staticClass: "title" }, [
          _vm._v(
            _vm._s(_vm.tc("noums.roomSingular")) + " " + _vm._s(_vm.index)
          ),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "description" }, [
          _vm._v(
            _vm._s(
              _vm.tc("booking.maxGuests", {
                maxGuestsAllowed: _vm.maxGuestsAllowed,
              })
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.isAditional
        ? _c("div", { staticClass: "input" }, [
            _c("button", {
              staticClass: "icon-close",
              attrs: { "aria-label": _vm.tc("booking.close") },
              on: {
                click: function ($event) {
                  return _vm.$emit("remove")
                },
              },
            }),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "input-line" }, [
      _c("div", { staticClass: "label" }, [
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.tc("noums.adultPlural"))),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "description" }, [
          _vm._v(
            _vm._s(
              _vm.selectedHotel.adultsAgeLabel
                ? _vm.selectedHotel.adultsAgeLabel
                : _vm.tc("booking.adultDescription")
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input" }, [
        _c(
          "button",
          {
            class: [
              "remove",
              { "--disabled": Number(_vm.adultGuestCount) <= 1 },
            ],
            attrs: {
              "aria-disabled": Number(_vm.adultGuestCount) <= 1,
              tabindex: "0",
              "aria-label":
                _vm.tc("booking.decreaseGuestCount") +
                " " +
                _vm.tc("noums.adultPlural"),
            },
            on: {
              click: function ($event) {
                _vm.adultGuestCount--
              },
            },
          },
          [_c("span", { staticClass: "icon-minus" })]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "value", attrs: { role: "status" } }, [
          _c("span", { staticClass: "sr-only" }, [
            _vm._v(_vm._s(_vm.tc("noums.adultPlural"))),
          ]),
          _vm._v(" " + _vm._s(_vm.adultGuestCount) + "\n      "),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            class: ["add", { "--disabled": _vm.maxGuestsReached }],
            attrs: {
              "aria-disabled": _vm.maxGuestsReached,
              tabindex: "0",
              "aria-label":
                _vm.tc("booking.increaseGuestCount") +
                " " +
                _vm.tc("noums.adultPlural"),
            },
            on: {
              click: function ($event) {
                _vm.adultGuestCount++
              },
            },
          },
          [_c("span", { staticClass: "icon-add" })]
        ),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.adultGuestCount,
            expression: "adultGuestCount",
          },
        ],
        attrs: { type: "number", max: _vm.maxGuestsAllowed, min: "1" },
        domProps: { value: _vm.adultGuestCount },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.adultGuestCount = $event.target.value
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("hr", { staticClass: "with-padding" }),
    _vm._v(" "),
    _c("div", { staticClass: "input-line" }, [
      _c("div", { staticClass: "label" }, [
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.tc("noums.childPlural"))),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "description" }, [
          _vm._v(
            _vm._s(
              _vm.selectedHotel.childrenAgeLabel
                ? _vm.selectedHotel.childrenAgeLabel
                : _vm.tc("booking.childDescription")
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input" }, [
        _c(
          "button",
          {
            class: [
              "remove",
              { "--disabled": Number(_vm.childGuestCount) === 0 },
            ],
            attrs: {
              "aria-disabled": Number(_vm.childGuestCount) === 0,
              tabindex: "0",
              "aria-label":
                _vm.tc("booking.decreaseGuestCount") +
                " " +
                _vm.tc("noums.childPlural"),
            },
            on: {
              click: function ($event) {
                _vm.childGuestCount--
              },
            },
          },
          [_c("span", { staticClass: "icon-minus" })]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "value", attrs: { role: "status" } }, [
          _c("span", { staticClass: "sr-only" }, [
            _vm._v(_vm._s(_vm.tc("noums.childPlural"))),
          ]),
          _vm._v(" " + _vm._s(_vm.childGuestCount) + "\n      "),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            class: ["add", { "--disabled": _vm.maxGuestsReached }],
            attrs: {
              "aria-disabled": _vm.maxGuestsReached,
              tabindex: "0",
              "aria-label":
                _vm.tc("booking.increaseGuestCount") +
                " " +
                _vm.tc("noums.childPlural"),
            },
            on: {
              click: function ($event) {
                _vm.childGuestCount++
              },
            },
          },
          [_c("span", { staticClass: "icon-add" })]
        ),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.childGuestCount,
            expression: "childGuestCount",
          },
        ],
        attrs: { type: "number", max: _vm.maxGuestsAllowed },
        domProps: { value: _vm.childGuestCount },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.childGuestCount = $event.target.value
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }